<template>
    <tableView  :selectable="false" :template-info="templateInfo" :isYearMonth="isYearMonth" :send-verify="true"/>
</template>
<script>
    import axios from "axios";
    import tableView from '@/components/tableView.vue';
    //import gqDirectoryUploader from '@/components/gqDirectoryUploader.vue';
    export default {
        name: "busView",
        components: {
            tableView,

            //gqDirectoryUploader
        },
        data() {
            return {
                templateInfo:{},//处理数据
                busType: "",//数据类型
                tabsValue: 0,
                tabList: [],//查询数据
                showWhat: "",
                show: false,
                isYearMonth:true
            }
        },
        mounted() {
            this.knowThis();
        },
        methods: {
            async knowThis() {
                let _this = this;
                console.log(this.$route.name)
              let localIpStr = localStorage.getItem("userLocalIP");
              if (localIpStr == null) localIpStr = "127.0.0.1";
              let jwtSession = localStorage.getItem("lyqtJwt");
              if (jwtSession == null) jwtSession = "";
              await axios({
                url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/route/template/" + `${this.$route.name}`,
                headers: {
                  "Authorization": "Bearer " + jwtSession,
                  "userIP": localIpStr
                },
                method: 'GET'})
                    .then(res => {
                        console.log("template");
                        console.log(res.data.content)
                        _this.tabList=res.data.content;
                        _this.templateInfo = _this.tabList.pages[0];
                        _this.templateInfo.moduleid=_this.tabList.moduleid;
                        _this.templateInfo.modulename=_this.tabList.modulename;
                    }).catch(err => {
                        console.log(err)
                    })
            },
            //选则时间段后触发
        },
    }
</script>

<style scoped>
    /*:deep(.el-tabs__content) {*/
    /*    padding: 0 15px;*/
    /*}*/
</style>
<style>
    /*.tabContainer {*/
    /*  width: 1200px;*/
    /*  height: auto;*/
    /*  margin: 0 auto;*/
    /*  background: #D4E3FB;*/
    /*  position: relative;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card{*/
    /*  border: none;*/
    /*  -webkit-box-shadow: none;*/
    /*  box-shadow: none;*/
    /*}*/
    /*.tabContainer > .el-tabs--border-card > .el-tabs__header {*/
    /*  !**!*/
    /*  background-color: #1B2945;*/
    /*  border: none;*/
    /*  border-top: 1px solid #1B2945;*/
    /*  border-radius: 3px;*/
    /*  margin: 0;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item{*/
    /*  color: #FFFFFF;*/
    /*  text-align: center;*/
    /*  border: none;*/
    /*  min-width: 80px;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {*/
    /*  color: #1B2945;*/
    /*  background-color: #FFF;*/
    /*  !*border-right-color: #DCDFE6;*!*/
    /*  !*border-left-color: #DCDFE6;*!*/
    /*  border: none;*/
    /*  box-shadow: none;*/
    /*}*/
    /*.el-tabs--border-card > .el-tabs__content {*/
    /*  margin: 0;*/
    /*  padding: 0;*/
    /*  height: 0;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {*/
    /*  color: #409EFF;*/
    /*  !*color: #FFFFFF;*!*/
    /*}*/
    /*!*input*!*/
    /*.tabContainer .tabInput {*/
    /*  background: none;*/
    /*  width: 160px;*/
    /*  height: 28px;*/
    /*  position: absolute;*/
    /*  right: 0;*/
    /*  top: 5px;*/
    /*  margin-right: 10px;*/
    /*}*/
    /*.tabContainer .el-input__inner {*/
    /*  -webkit-appearance: none;*/
    /*  background: none;*/
    /*  border-radius: 4px;*/
    /*  border: 1px solid #DCDFE6;*/
    /*  -webkit-box-sizing: border-box;*/
    /*  box-sizing: border-box;*/
    /*  color: #606266;*/
    /*  display: inline-block;*/
    /*  font-size: 15px;*/
    /*  height: 28px;*/
    /*  line-height: 28px;*/
    /*  outline: 0;*/
    /*  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);*/
    /*  width: 100%;*/
    /*}*/
    /*.tabContainer .el-input__icon {*/
    /*  height: 100%;*/
    /*  width: 25px;*/
    /*  text-align: center;*/
    /*  -webkit-transition: all .3s;*/
    /*  transition: all .3s;*/
    /*  line-height: 28px;*/
    /*}*/
    /*.el-tabs__item.is-active {*/
    /*    color: #409EFF;*/
    /*    background-color: white;*/
    /*}*/
    /*.el-tabs__item {*/
    /*    background-color: #EEEEEE;*/
    /*    height: 40px;*/
    /*    right: 0;*/
    /*    top: 5px;*/
    /*    margin-right: 10px;*/

    /*    !*padding: 0 20px;*!*/
    /*    -webkit-box-sizing: border-box;*/
    /*    box-sizing: border-box;*/
    /*    line-height: 40px;*/
    /*    display: inline-block;*/
    /*    list-style: none;*/
    /*    font-size: 14px;*/
    /*    font-weight: 500;*/
    /*    !*color: #303133;*!*/
    /*    !*color: gray;*!*/
    /*    position: relative;*/

    /*    !*-webkit-appearance: none;*!*/
    /*    !*background: none;*!*/
    /*    border-radius: 10px;*/
    /*    border: 1px solid #DCDFE6;*/
    /*    -webkit-box-sizing: border-box;*/
    /*    box-sizing: border-box;*/
    /*    color: #606266;*/
    /*    display: inline-block;*/
    /*    !*font-size: 15px;*!*/
    /*    !*height: 28px;*!*/
    /*    !*line-height: 28px;*!*/
    /*    outline: 0;*/
    /*    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);*/
    /*    !*width: 100%;*!*/
    /*}*/
    /*.el-tabs__item:hover {*/
    /*    color: #409EFF;*/
    /*    cursor: pointer;*/
    /*}*/
    /*.el-tabs__active-bar {*/
    /*    position: absolute;*/
    /*    bottom: 0;*/
    /*    left: 0;*/
    /*    height: 2px;*/
    /*    !*background-color: #409EFF;*!*/
    /*    background: none;*/
    /*    z-index: 1;*/
    /*    transition: transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);*/
    /*    list-style: none;*/
    /*}*/
    /*.el-tabs__nav {*/
    /*  white-space: nowrap;*/
    /*  position: relative;*/
    /*  border-bottom: 2px solid gray;*/
    /*  transition: transform .3s,-webkit-transform .3s;*/
    /*  float: left;*/
    /*  z-index: 1;*/
    /*}*/
</style>
